export const changeCropScoreSelectedReducer = (state = "", action) => {
  switch (action.type) {
    case "CHANGE_CropScoreSelected":
      return action.payload.cropScoreSelected;
    default:
      return state;
  }
};
